/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_Mail_TemplatesInputs */

const en_admin_sidebar_mail_templates = /** @type {(inputs: Admin_Sidebar_Mail_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mail templates`)
};

const de_admin_sidebar_mail_templates = /** @type {(inputs: Admin_Sidebar_Mail_TemplatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Vorlagen`)
};

/**
* | output |
* | --- |
* | "Mail templates" |
*
* @param {Admin_Sidebar_Mail_TemplatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_mail_templates = /** @type {((inputs?: Admin_Sidebar_Mail_TemplatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_Mail_TemplatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_mail_templates(inputs)
	return en_admin_sidebar_mail_templates(inputs)
});